import { Component, OnInit, Input } from '@angular/core';
import { ApiService } from './../../shared/api.service';
import { Router, ActivatedRoute } from '@angular/router';
import { saveAs } from 'file-saver';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { UserService } from './../../@core/data/users.service';
import { ConfirmationService } from 'primeng/api';



@Component({
  selector: 'educational',
  templateUrl: "./educationalformyearly.component.html",
  providers: [ConfirmationService]
})
export class EducationalFormYearComponent implements OnInit {
  FeedbackForm: FormGroup;
  @Input() user_id: any;
  @Input() edu_id: any;
  @Input() amount_paid: string;
  @Input() admin_show: string;
  @Input() autoName: string;
  @Input() showSpecialization: string;
  @Input() course_name_auto: string;
  @Input() education_level_auto: string;
  @Input() college_year_auto: string;
  @Input() doubbleDegree: any;
  // @Input() courseShortName: string;

  validations_flag = false;
  feedback_message;
  showExperience = false;
  totalMarks: number;
  totalMarksOut: number;
  @Input() yearValue = [];
  formData: FormGroup;
  edu_form: FormGroup;
  years_array;
  courseValidation = true;
  collegeYearValidation = true;
  classValidation = true;
  monthValidation = true;
  yearValidation = true;
  attemptValidation = true;
  instructionValidation = true;
  edu_data;
  course_data;
  user: any;
  hourValue: any;
  hourValue8: any;
  hourValue7: any;
  hourValue6: any;
  hourValue5: any;
  hourValue4: any;
  hourValue3: any;
  hourValue2: any;
  hourValue9: any;
  hourValue10: any;
  hourValue11: any;
  hourValue12: any;
  lecVal1: any;
  lecVal2: any;
  lecVal3: any;
  lecVal4: any;
  lecVal5: any;
  lecVal6: any;
  lecVal7: any;
  lecVal8: any;
  lecVal9: any;
  lecVal10: any;
  lecVal11: any;
  lecVal12: any;

  public filterInput = new FormControl();
  public filterInput2 = new FormControl();
  public filterInput3 = new FormControl();
  public filterInput4 = new FormControl();
  public filterInput5 = new FormControl();
  public filterInput6 = new FormControl();
  public filterInput7 = new FormControl();
  public filterInput8 = new FormControl();
  public filterInput9 = new FormControl();
  public filterInput10 = new FormControl();
  public filterInput11 = new FormControl();
  public filterInput12 = new FormControl();
  subjectName: any;
  withoutCodeSub: any;
  subjectName2: any;
  withoutCodeSub2: any;
  withoutCodeSub3: any;
  subjectName3: any;
  subjectName4: any;
  withoutCodeSub4: any;
  subjectName5: any;
  withoutCodeSub5: any;
  subjectName6: any;
  withoutCodeSub6: any;
  subjectName7: any;
  withoutCodeSub7: any;
  subjectName8: any;
  withoutCodeSub8: any;
  subjectName9: any;
  withoutCodeSub9: any;
  subjectName10: any;
  withoutCodeSub10: any;
  subjectName11: any;
  withoutCodeSub11: any;
  subjectName12: any;
  withoutCodeSub12: any;
  course_code1: any;
  course_code2: any;
  course_code3: any;
  course_code4: any;
  course_code5: any;
  course_code6: any;
  course_code7: any;
  course_code8: any;
  course_code9: any;
  course_code10: any;
  course_code11: any;
  course_code12: any;
  prac_hour1: any;
  prac_hour2: any;
  prac_hour3: any;
  prac_hour4: any;
  prac_hour5: any;
  prac_hour6: any;
  prac_hour7: any;
  prac_hour8: any;
  prac_hour9: any;
  prac_hour10: any;
  prac_hour11: any;
  prac_hour12: any;
  lec_per_week1: string;
  lec_per_week2: string;
  lec_per_week3: string;
  lec_per_week4: string;
  lec_per_week5: string;
  lec_per_week6: string;
  lec_per_week7: string;
  lec_per_week8: string;
  lec_per_week9: string;
  lec_per_week10: string;
  lec_per_week11: string;
  lec_per_week12: string;
  public filterText: any;
  public filterText2: any;
  filterText3: any;
  public filterText4: any;
  public filterText5: any;
  public filterText6: any;
  public filterText7: any;
  public filterText8: any;
  public filterText9: any;
  public filterText10: any;
  public filterText11: any;
  public filterText12: any;
  autocheck = true;
  showcodeDropdown: boolean = true;
  showcodeDropdown2: boolean = true;
  showcodeDropdown3: boolean = true;
  showcodeDropdown4: boolean = true;
  showcodeDropdown5: boolean = true;
  showcodeDropdown6: boolean = true;
  showcodeDropdown7: boolean = true;
  showcodeDropdown8: boolean = true;
  showcodeDropdown9: boolean = true;
  showcodeDropdown10: boolean = true;
  showcodeDropdown11: boolean = true;
  showcodeDropdown12: boolean = true;
  newcourse_code = [];
  course_name;
  college_year;
  edu_level;

  isLoadingResults: boolean = false;

  constructor(protected api: ApiService,
    private router: Router,
    private userService: UserService,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    public toasterService: NbToastrService,
    private confirmationService: ConfirmationService,
    protected ref: NbDialogRef<EducationalFormYearComponent>) { }

  async ngOnInit() {
    // this.userService.onUserChange()
    // .subscribe((user: any) => this.user = user);
    // if(this.user.role == 'admin'){
    //   this.admin_show = false;
    // }

    // Initialize formData
    this.formData = this.formBuilder.group({
      courseCode: [''], // Example control for course code
    });

    this.edu_form = this.formBuilder.group({
      courseNameCtrl: ['', Validators.required],
      collegeYearCtrl: ['', Validators.required],
      overallclassCtrl: ['', Validators.required],
      monthCtrl: ['', Validators.required],
      yearCtrl: ['', Validators.required],
      overmarksobtCtrl: ['', Validators.required],
      overmarksoutCtrl: ['', Validators.required],
      subjectFirstCtrl: [''],
      markFirstCtrl: ['', Validators.required],
      markFirstOutCtrl: ['', Validators.required],
      subjectSecondCtrl: [''],
      markSecondCtrl: [''],
      markSecondOutCtrl: [''],
      subjectThirdCtrl: [''],
      markThirdCtrl: [''],
      markThirdOutCtrl: [''],
      subjectFourthCtrl: [''],
      markFourthCtrl: [''],
      markFourthOutCtrl: [''],
      subjectFifthCtrl: [''],
      markFifthCtrl: [''],
      markFifthOutCtrl: [''],
      subjectSixthCtrl: [''],
      markSixthCtrl: [''],
      markSixthOutCtrl: [''],
      subjectSeventhCtrl: [''],
      markSeventhCtrl: [''],
      markSeventhOutCtrl: [''],
      subjectEighthCtrl: [''],
      markEighthCtrl: [''],
      markEighthOutCtrl: [''],
      subjectNinthCtrl: [''],
      markNinthCtrl: [''],
      markNinthOutCtrl: [''],
      subjectTenthCtrl: [''],
      markTenthCtrl: [''],
      markTenthOutCtrl: [''],
      subjectElevanthCtrl: [''],
      markElevanthCtrl: [''],
      markElevanthOutCtrl: [''],
      subjectTwelfthCtrl: [''],
      markTwelfthCtrl: [''],
      markTwelfthOutCtrl: [''],
      instructionCtrl: ['', Validators.required],
      lecturehourFirstCtrl: [''],
      lecturehourSecondCtrl: [''],
      lecturehourThirdCtrl: [''],
      lecturehourFourthCtrl: [''],
      lecturehourFifthCtrl: [''],
      lecturehourSixCtrl: [''],
      lecturehourSeventhCtrl: [''],
      lecturehourEighthCtrl: [''],
      lecturehourNinthCtrl: [''],
      lecturehourTenthCtrl: [''],
      lecturehourElevanthCtrl: [''],
      lecturehourTwelfthCtrl: [''],
      practicalhourFirstCtrl: [''],
      practicalhourSecondCtrl: [''],
      practicalhourThirdCtrl: [''],
      practicalhourFourthCtrl: [''],
      practicalhourFifthCtrl: [''],
      practicalhourSixCtrl: [''],
      practicalhourSeventhCtrl: [''],
      practicalhourEighthCtrl: [''],
      practicalhourNinthCtrl: [''],
      practicalhourTenthCtrl: [''],
      practicalhourElevanthCtrl: [''],
      practicalhourTwelfthCtrl: [''],
      specialInstrctionCtrl: [''],
      totalweeksCtrl: [''],
      specializationCtrl: [''],
    })

    if (this.college_year_auto == 'firstYear') {
      this.college_year = 'First';
    } else if (this.college_year_auto == 'secondYear') {
      this.college_year = 'Second';
    } else if (this.college_year_auto == 'thirdYear') {
      this.college_year = 'Third';
    }

    this.api.getCouses().subscribe((data: any) => {
      if (data['status'] == 200) {
        this.course_data = data['data'];

        if (this.course_name_auto != null) {
          this.course_data.forEach(element => {
            if (element.CourseName == this.course_name_auto || element.CourseShortForm == this.course_name_auto) {
              this.course_name = element.CourseShortForm;
              this.edu_level = element.type;
            }
          });
        }
      } else {

      }


      this.api.getCouseCodeYearly(this.course_name, this.college_year).subscribe((data: any) => {
        if (data['status'] == 200) {
          this.autocheck = false
          this.filterText = "";
          this.course_code1 = data['data'];
          

          this.filterInput
            .valueChanges
            .debounceTime(200)
            .subscribe(term => {
              this.filterText = term;

            });

          this.filterText2 = "";
          this.course_code2 = data['data'];

          this.filterInput2
            .valueChanges
            .debounceTime(200)
            .subscribe(term => {
              //this.filterText = term;
              this.filterText2 = term;
            });

          this.filterText3 = "";
          this.course_code3 = data['data']
          this.filterInput3
            .valueChanges
            .debounceTime(200)
            .subscribe(term => {
              this.filterText3 = term;
              //this.filterText2 = term;
            });

          this.filterText4 = "";
          this.course_code4 = data['data']
          this.filterInput4
            .valueChanges
            .debounceTime(200)
            .subscribe(term => {
              this.filterText4 = term;
              //this.filterText2 = term;
            });

          this.filterText5 = "";
          this.course_code5 = data['data']
          this.filterInput5
            .valueChanges
            .debounceTime(200)
            .subscribe(term => {
              this.filterText5 = term;
              //this.filterText2 = term;
            });

          this.filterText6 = "";
          this.course_code6 = data['data']
          this.filterInput6
            .valueChanges
            .debounceTime(200)
            .subscribe(term => {
              this.filterText6 = term;
              //this.filterText2 = term;
            });

          this.filterText7 = "";
          this.course_code7 = data['data']
          this.filterInput7
            .valueChanges
            .debounceTime(200)
            .subscribe(term => {
              this.filterText7 = term;
              //this.filterText2 = term;
            });

          this.filterText8 = "";
          this.course_code8 = data['data']
          this.filterInput8
            .valueChanges
            .debounceTime(200)
            .subscribe(term => {
              this.filterText8 = term;
              //this.filterText2 = term;
            });

          this.filterText9 = "";
          this.course_code9 = data['data']
          this.filterInput9
            .valueChanges
            .debounceTime(200)
            .subscribe(term => {
              this.filterText9 = term;
              //this.filterText2 = term;
            });

          this.filterText10 = "";
          this.course_code10 = data['data']
          this.filterInput10
            .valueChanges
            .debounceTime(200)
            .subscribe(term => {
              this.filterText10 = term;
              //this.filterText2 = term;
            });

          this.filterText11 = "";
          this.course_code11 = data['data']
          this.filterInput11
            .valueChanges
            .debounceTime(200)
            .subscribe(term => {
              this.filterText11 = term;
              //this.filterText2 = term;
            });

          this.filterText12 = "";
          this.course_code12 = data['data']
          this.filterInput12
            .valueChanges
            .debounceTime(200)
            .subscribe(term => {
              this.filterText12 = term;
              //this.filterText2 = term;
            });

        } else {

        }
      });

      // this.api.getCouseCodeYearly(this.course_name, this.college_year).subscribe((info: any) => {
      //   if (info['status'] == 200) {
      //     this.autocheck = false
      //     this.filterText2 = "";
      //     this.course_code2 = info['data'];

      //     this.filterInput2
      //       .valueChanges
      //       .debounceTime(200)
      //       .subscribe(term => {
      //         //this.filterText = term;
      //         this.filterText2 = term;
      //       });

      //   } else {

      //   }
      // });

      // this.api.getCouseCodeYearly(this.course_name, this.college_year).subscribe((data: any) => {

      //   if (data['status'] == 200) {
      //     this.autocheck = false
      //     this.course_code3 = data['data']
      //     this.filterText3 = "";
      //     this.filterInput3
      //       .valueChanges
      //       .debounceTime(200)
      //       .subscribe(term => {
      //         this.filterText3 = term;
      //         //this.filterText2 = term;
      //       });



      //   } else {

      //   }
      // });

      // this.api.getCouseCodeYearly(this.course_name, this.college_year).subscribe((data: any) => {

      //   if (data['status'] == 200) {
      //     this.autocheck = false
      //     this.course_code4 = data['data']
      //     this.filterText4 = "";
      //     this.filterInput4
      //       .valueChanges
      //       .debounceTime(200)
      //       .subscribe(term => {
      //         this.filterText4 = term;
      //         //this.filterText2 = term;
      //       });



      //   } else {

      //   }
      // });

      // this.api.getCouseCodeYearly(this.course_name, this.college_year).subscribe((data: any) => {

      //   if (data['status'] == 200) {
      //     this.autocheck = false
      //     this.course_code5 = data['data']
      //     this.filterText5 = "";
      //     this.filterInput5
      //       .valueChanges
      //       .debounceTime(200)
      //       .subscribe(term => {
      //         this.filterText5 = term;
      //         //this.filterText2 = term;
      //       });



      //   } else {

      //   }
      // });

      // this.api.getCouseCodeYearly(this.course_name, this.college_year).subscribe((data: any) => {

      //   if (data['status'] == 200) {
      //     this.autocheck = false
      //     this.course_code6 = data['data']
      //     this.filterText6 = "";
      //     this.filterInput6
      //       .valueChanges
      //       .debounceTime(200)
      //       .subscribe(term => {
      //         this.filterText6 = term;
      //         //this.filterText2 = term;
      //       });



      //   } else {

      //   }
      // });

      // this.api.getCouseCodeYearly(this.course_name, this.college_year).subscribe((data: any) => {

      //   if (data['status'] == 200) {
      //     this.autocheck = false
      //     this.course_code7 = data['data']
      //     this.filterText7 = "";
      //     this.filterInput7
      //       .valueChanges
      //       .debounceTime(200)
      //       .subscribe(term => {
      //         this.filterText7 = term;
      //         //this.filterText2 = term;
      //       });



      //   } else {

      //   }
      // });

      // this.api.getCouseCodeYearly(this.course_name, this.college_year).subscribe((data: any) => {

      //   if (data['status'] == 200) {
      //     this.autocheck = false
      //     this.course_code8 = data['data']
      //     this.filterText8 = "";
      //     this.filterInput8
      //       .valueChanges
      //       .debounceTime(200)
      //       .subscribe(term => {
      //         this.filterText8 = term;
      //         //this.filterText2 = term;
      //       });



      //   } else {

      //   }
      // });

      // this.api.getCouseCodeYearly(this.course_name, this.college_year).subscribe((data: any) => {

      //   if (data['status'] == 200) {
      //     this.autocheck = false
      //     this.course_code9 = data['data']
      //     this.filterText9 = "";
      //     this.filterInput9
      //       .valueChanges
      //       .debounceTime(200)
      //       .subscribe(term => {
      //         this.filterText9 = term;
      //         //this.filterText2 = term;
      //       });



      //   } else {

      //   }
      // });

      // this.api.getCouseCodeYearly(this.course_name, this.college_year).subscribe((data: any) => {

      //   if (data['status'] == 200) {
      //     this.autocheck = false
      //     this.course_code10 = data['data']
      //     this.filterText10 = "";
      //     this.filterInput10
      //       .valueChanges
      //       .debounceTime(200)
      //       .subscribe(term => {
      //         this.filterText10 = term;
      //         //this.filterText2 = term;
      //       });



      //   } else {

      //   }
      // });

    });

    const now = new Date().getUTCFullYear();
    this.years_array = Array(now - (now - 50)).fill('').map((v, idx) => now - idx);


    if (this.user_id != null && this.edu_id != null) {
      this.api.getEducation(this.edu_id, this.user_id)
        .subscribe(
          (data: any) => {
            if (data['status'] == 200) {
              this.edu_data = data['data'];
              this.course_name = this.edu_data.CourseName;
              

              this.college_year = this.edu_data.CollegeYear;
              if (this.edu_data.Subject_First != null && this.edu_data.Subject_First != '' && this.edu_data.Subject_First != undefined) {
                this.showcodeDropdown = false

              } else {

                this.showcodeDropdown = true
              }
              if (this.edu_data.Subject_Second != null) {
                this.showcodeDropdown2 = false

              } else {

                this.showcodeDropdown2 = true
              }
              if (this.edu_data.Subject_Third != null && this.edu_data.Subject_Third != '' && this.edu_data.Subject_Third != undefined) {
                this.showcodeDropdown3 = false

              } else {

                this.showcodeDropdown3 = true
              }
              if (this.edu_data.Subject_Fourth != null && this.edu_data.Subject_Fourth != '' && this.edu_data.Subject_Fourth != undefined) {
                this.showcodeDropdown4 = false

              } else {

                this.showcodeDropdown4 = true
              }
              if (this.edu_data.Subject_Fifth != null && this.edu_data.Subject_Fifth != '' && this.edu_data.Subject_Fifth != undefined) {
                this.showcodeDropdown5 = false

              } else {

                this.showcodeDropdown5 = true
              }
              if (this.edu_data.Subject_Six != null && this.edu_data.Subject_Six != '' && this.edu_data.Subject_Six != undefined) {
                this.showcodeDropdown6 = false

              } else {

                this.showcodeDropdown6 = true
              }
              if (this.edu_data.Subject_Seventh != null && this.edu_data.Subject_Seventh != '' && this.edu_data.Subject_Seventh != undefined) {
                this.showcodeDropdown7 = false

              } else {

                this.showcodeDropdown7 = true
              }
              if (this.edu_data.Subject_Eighth != null && this.edu_data.Subject_Eighth != '' && this.edu_data.Subject_Eighth != undefined) {
                this.showcodeDropdown8 = false

              } else {

                this.showcodeDropdown8 = true
              }
              if (this.edu_data.Subject_Ninth != null && this.edu_data.Subject_Ninth != '' && this.edu_data.Subject_Ninth != undefined) {
                this.showcodeDropdown9 = false

              } else {

                this.showcodeDropdown9 = true
              }
              if (this.edu_data.Subject_Tenth != null && this.edu_data.Subject_Tenth != '' && this.edu_data.Subject_Tenth != undefined) {
                this.showcodeDropdown10 = false

              } else {

                this.showcodeDropdown10 = true
              }
              if (this.edu_data.practical_hour_First) {

              } else {

              }
              if (this.edu_data.Subject_Elevanth != null && this.edu_data.Subject_Elevanth != '' && this.edu_data.Subject_Elevanth != undefined) {
                this.showcodeDropdown11 = false

              } else {

                this.showcodeDropdown11 = true
              }

              if (this.edu_data.Subject_Twelfth != null && this.edu_data.Subject_Twelfth != '' && this.edu_data.Subject_Twelfth != undefined) {
                this.showcodeDropdown12 = false

              } else {

                this.showcodeDropdown12 = true
              }



            } else {

            }
          });
    } else {

    }
  }

  getCourse(value) {

    //this.filterText = "";
    this.subjectName = value

    if (this.course_name_auto == 'B.Sc.' || this.course_name_auto == 'Bachelor of Science' || this.course_name_auto == 'M.Sc.' || this.course_name_auto == 'Master of Science' || this.course_name_auto == 'J.C.') {
      if (value.prac == "yes") {

        this.prac_hour1 = value.Lec_per_Week;
        this.lec_per_week1 = "-";
      } else {
        this.lec_per_week1 = value.Lec_per_Week;
        this.prac_hour1 = "-";

      }
    } else {
      this.lec_per_week1 = value.Lec_per_Week;
      this.prac_hour1 = "";
    }

    var count = 0
    this.newcourse_code = [];
    this.course_code1.forEach(element => {
      count++
      if (element['id'] == this.subjectName['id']) {

      } else {

        this.newcourse_code.push(element)


      }

      if (count == this.course_code1.length) {
        this.course_code1 = this.newcourse_code
      }
    })
    //this.filterPlaceholder = "Search";
    // this.adminApi.getAllCourse(value).subscribe((data)=>{
    //   this.courses = data['data'];
    // })
    // this.filterInput
    //   .valueChanges
    //   .debounceTime(200)
    //   .subscribe(term => {
    //   this.filterText = term;
    // });
  }

  getSubject(event: any) {

    this.withoutCodeSub = event.target.value
    if (this.subjectName) {

    } else {

    }
  }

  getCourse2(value) {

    //this.filterText = "";
    this.subjectName2 = value
    if (this.course_name_auto == 'B.Sc.' || this.course_name_auto == 'Bachelor of Science' || this.course_name_auto == 'M.Sc.' || this.course_name_auto == 'Master of Science' || this.course_name_auto == 'J.C.') {
      if (value.prac == "yes") {

        this.prac_hour2 = value.Lec_per_Week;
        this.lec_per_week2 = "-";
      } else {
        this.lec_per_week2 = value.Lec_per_Week;
        this.prac_hour2 = "-";

      }
    } else {
      this.lec_per_week2 = value.Lec_per_Week;
      this.prac_hour2 = "";
    }

    var count = 0
    this.newcourse_code = [];
    this.course_code3.forEach(element => {
      count++
      if (element['id'] == this.subjectName['id'] || element['id'] == this.subjectName2['id']) {

      } else {

        this.newcourse_code.push(element)


      }

      if (count == this.course_code3.length) {
        this.course_code3 = [];
        this.course_code3 = this.newcourse_code
      }
    })
  }

  getSubject2(event: any) {

    this.withoutCodeSub2 = event.target.value

  }

  getCourse3(value) {
    this.subjectName3 = value
    if (this.course_name_auto == 'B.Sc.' || this.course_name_auto == 'Bachelor of Science' || this.course_name_auto == 'M.Sc.' || this.course_name_auto == 'Master of Science' || this.course_name_auto == 'J.C.') {
      if (value.prac == "yes") {

        this.prac_hour3 = value.Lec_per_Week;
        this.lec_per_week3 = "-";
      } else {
        this.lec_per_week3 = value.Lec_per_Week;
        this.prac_hour3 = "-";

      }
    } else {
      this.lec_per_week3 = value.Lec_per_Week;
      this.prac_hour3 = "-";
    }

    var count = 0
    this.newcourse_code = [];
    this.course_code4.forEach(element => {
      count++
      if (element['id'] == this.subjectName['id'] || element['id'] == this.subjectName2['id'] || element['id'] == this.subjectName3['id']) {

      } else {

        this.newcourse_code.push(element)


      }

      if (count == this.course_code4.length) {
        this.course_code4 = [];
        this.course_code4 = this.newcourse_code
      }
    })
  }

  getSubject3(event: any) {
    this.withoutCodeSub3 = event.target.value
  }

  getCourse4(value) {

    this.subjectName4 = value
    if (this.course_name_auto == 'B.Sc.' || this.course_name_auto == 'Bachelor of Science' || this.course_name_auto == 'M.Sc.' || this.course_name_auto == 'Master of Science' || this.course_name_auto == 'J.C.') {
      if (value.prac == "yes") {

        this.prac_hour4 = value.Lec_per_Week;
        this.lec_per_week4 = "-";
      } else {
        this.lec_per_week4 = value.Lec_per_Week;
        this.prac_hour4 = "-";

      }
    } else {
      this.lec_per_week4 = value.Lec_per_Week;
      this.prac_hour4 = "";
    }
    var count = 0
    this.newcourse_code = [];
    this.course_code5.forEach(element => {
      count++
      if (element['id'] == this.subjectName['id'] || element['id'] == this.subjectName2['id'] || element['id'] == this.subjectName3['id'] || element['id'] == this.subjectName4['id']) {

      } else {

        this.newcourse_code.push(element)


      }

      if (count == this.course_code5.length) {
        this.course_code5 = [];
        this.course_code5 = this.newcourse_code
      }
    })
  }

  getSubject4(event: any) {

    this.withoutCodeSub4 = event.target.value

  }

  getCourse5(value) {

    this.subjectName5 = value
    if (this.course_name_auto == 'B.Sc.' || this.course_name_auto == 'Bachelor of Science' || this.course_name_auto == 'M.Sc.' || this.course_name_auto == 'Master of Science' || this.course_name_auto == 'J.C.') {

      if (value.prac == "yes") {

        this.prac_hour5 = value.Lec_per_Week;
        this.lec_per_week5 = "-";
      } else {
        this.lec_per_week5 = value.Lec_per_Week;
        this.prac_hour5 = "-";

      }
    } else {
      this.lec_per_week5 = value.Lec_per_Week;
      this.prac_hour5 = "";
    }

    var count = 0
    this.newcourse_code = [];
    
    this.course_code6.forEach(element => {
      count++
      if (element['id'] == this.subjectName['id'] || element['id'] == this.subjectName2['id'] || element['id'] == this.subjectName3['id'] || element['id'] == this.subjectName4['id'] || element['id'] == this.subjectName5['id']) {

      } else {

        this.newcourse_code.push(element)


      }

      if (count == this.course_code6.length) {
        this.course_code6 = [];
        this.course_code6 = this.newcourse_code
      }
    })
  }

  getSubject5(event: any) {

    this.withoutCodeSub5 = event.target.value

  }

  getCourse6(value) {

    this.subjectName6 = value
    if (this.course_name_auto == 'B.Sc.' || this.course_name_auto == 'Bachelor of Science' || this.course_name_auto == 'M.Sc.' || this.course_name_auto == 'Master of Science' || this.course_name_auto == 'J.C.') {
      if (value.prac == "yes") {

        this.prac_hour6 = value.Lec_per_Week;
        this.lec_per_week6 = "-";
      } else {
        this.lec_per_week6 = value.Lec_per_Week;
        this.prac_hour6 = "-";

      }
    } else {
      this.lec_per_week6 = value.Lec_per_Week;
      this.prac_hour6 = "";
    }

    var count = 0
    this.newcourse_code = [];
    this.course_code7.forEach(element => {
      count++
      if (element['id'] == this.subjectName['id'] || element['id'] == this.subjectName2['id'] || element['id'] == this.subjectName3['id'] || element['id'] == this.subjectName4['id'] || element['id'] == this.subjectName5['id'] || element['id'] == this.subjectName6['id']) {

      } else {

        this.newcourse_code.push(element)


      }

      if (count == this.course_code7.length) {
        this.course_code7 = [];
        this.course_code7 = this.newcourse_code
      }
    })
  }

  getSubject6(event: any) {

    this.withoutCodeSub6 = event.target.value

  }

  getCourse7(value) {

    this.subjectName7 = value
    if (this.course_name_auto == 'B.Sc.' || this.course_name_auto == 'Bachelor of Science' || this.course_name_auto == 'M.Sc.' || this.course_name_auto == 'Master of Science' || this.course_name_auto == 'J.C.') {
      if (value.prac == "yes") {

        this.prac_hour7 = value.Lec_per_Week;
        this.lec_per_week7 = "-";
      } else {
        this.lec_per_week7 = value.Lec_per_Week;
        this.prac_hour7 = "-";

      }
    } else {
      this.lec_per_week7 = value.Lec_per_Week;
      this.prac_hour7 = "";
    }

    var count = 0
    this.newcourse_code = [];
    this.course_code8.forEach(element => {
      count++
      if (element['id'] == this.subjectName['id'] || element['id'] == this.subjectName2['id'] || element['id'] == this.subjectName3['id'] || element['id'] == this.subjectName4['id'] || element['id'] == this.subjectName5['id'] || element['id'] == this.subjectName6['id'] || element['id'] == this.subjectName7['id']) {

      } else {

        this.newcourse_code.push(element)


      }

      if (count == this.course_code8.length) {
        this.course_code8 = [];
        this.course_code8 = this.newcourse_code
      }
    })
  }

  getSubject7(event: any) {

    this.withoutCodeSub7 = event.target.value

  }

  getCourse8(value) {

    this.subjectName8 = value
    if (this.course_name_auto == 'B.Sc.' || this.course_name_auto == 'Bachelor of Science' || this.course_name_auto == 'M.Sc.' || this.course_name_auto == 'Master of Science' || this.course_name_auto == 'J.C.') {
      if (value.prac == "yes") {

        this.prac_hour8 = value.Lec_per_Week;
        this.lec_per_week8 = "-";
      } else {
        this.lec_per_week8 = value.Lec_per_Week;
        this.prac_hour8 = "-";

      }
    } else {
      this.lec_per_week8 = value.Lec_per_Week;
      this.prac_hour8 = "";
    }
  }

  getSubject8(event: any) {

    this.withoutCodeSub8 = event.target.value

  }

  getCourse9(value) {

    this.subjectName9 = value
    if (this.course_name_auto == 'B.Sc.' || this.course_name_auto == 'Bachelor of Science' || this.course_name_auto == 'M.Sc.' || this.course_name_auto == 'Master of Science' || this.course_name_auto == 'J.C.') {
      if (value.prac == "yes") {

        this.prac_hour9 = value.Lec_per_Week;
        this.lec_per_week9 = "-";
      } else {
        this.lec_per_week9 = value.Lec_per_Week;
        this.prac_hour9 = "-";

      }
    } else {
      this.lec_per_week9 = value.Lec_per_Week;
      this.prac_hour9 = "";
    }
  }

  getSubject9(event: any) {

    this.withoutCodeSub9 = event.target.value

  }

  getCourse10(value) {

    this.subjectName10 = value
    if (this.course_name_auto == 'B.Sc.' || this.course_name_auto == 'Bachelor of Science' || this.course_name_auto == 'M.Sc.' || this.course_name_auto == 'Master of Science' || this.course_name_auto == 'J.C.') {
      if (value.prac == "yes") {

        this.prac_hour10 = value.Lec_per_Week;
        this.lec_per_week10 = "-";
      } else {
        this.lec_per_week10 = value.Lec_per_Week;
        this.prac_hour10 = "-";

      }
    } else {
      this.lec_per_week10 = value.Lec_per_Week;
      this.prac_hour10 = "";
    }
  }

  getSubject10(event: any) {

    this.withoutCodeSub10 = event.target.value

  }

  getCourse11(value) {

    this.subjectName11 = value
    if (this.course_name_auto == 'B.Sc.' || this.course_name_auto == 'Bachelor of Science' || this.course_name_auto == 'M.Sc.' || this.course_name_auto == 'Master of Science' || this.course_name_auto == 'J.C.') {
      if (value.prac == "yes") {

        this.prac_hour11 = value.Lec_per_Week;
        this.lec_per_week11 = "-";
      } else {
        this.lec_per_week11 = value.Lec_per_Week;
        this.prac_hour11 = "-";

      }
    } else {
      this.lec_per_week11 = value.Lec_per_Week;
      this.prac_hour11 = "";
    }
  }

  getSubject11(event: any) {

    this.withoutCodeSub11 = event.target.value

  }

  getCourse12(value) {

    this.subjectName12 = value
    if (this.course_name_auto == 'B.Sc.' || this.course_name_auto == 'Bachelor of Science' || this.course_name_auto == 'M.Sc.' || this.course_name_auto == 'Master of Science' || this.course_name_auto == 'J.C.') {
      if (value.prac == "yes") {

        this.prac_hour12 = value.Lec_per_Week;
        this.lec_per_week12 = "-";
      } else {
        this.lec_per_week12 = value.Lec_per_Week;
        this.prac_hour12 = "-";

      }
    } else {
      this.lec_per_week12 = value.Lec_per_Week;
      this.prac_hour12 = "";
    }
  }

  getSubject12(event: any) {

    this.withoutCodeSub12 = event.target.value

  }

  saveEdu() {
    this.courseValidation = true;
    this.collegeYearValidation = true;
    this.classValidation = true;
    this.monthValidation = true;
    this.yearValidation = true;
    this.attemptValidation = true;
    this.instructionValidation = true;

    if (this.edu_form.valid == false) {
      this.edu_form.controls.courseNameCtrl.markAsDirty();
      this.edu_form.controls.overmarksoutCtrl.markAsDirty();
      this.edu_form.controls.overmarksobtCtrl.markAsDirty();
      this.edu_form.controls.subjectFirstCtrl.markAsDirty();
      this.edu_form.controls.markFirstCtrl.markAsDirty();
      this.edu_form.controls.markFirstOutCtrl.markAsDirty();
      this.edu_form.controls.specializationCtrl.markAsDirty();
      // this.edu_form.controls.subjectSecondCtrl.markAsDirty();
      // this.edu_form.controls.markSecondCtrl.markAsDirty();
      // this.edu_form.controls.markSecondOutCtrl.markAsDirty();
      // this.edu_form.controls.subjectThirdCtrl.markAsDirty();
      // this.edu_form.controls.markThirdCtrl.markAsDirty();
      // this.edu_form.controls.markThirdOutCtrl.markAsDirty();
      // this.edu_form.controls.subjectFourthCtrl.markAsDirty();
      // this.edu_form.controls.markFourthCtrl.markAsDirty();
      // this.edu_form.controls.markFourthOutCtrl.markAsDirty();
      this.edu_form.controls.instructionCtrl.markAsDirty();

      if (this.edu_form.controls.instructionCtrl.value === null || this.edu_form.controls.instructionCtrl.value === '' || this.edu_form.controls.instructionCtrl.value === undefined) {
        this.instructionValidation = false;
      } else {
        this.instructionValidation = true;
      }

      if (this.edu_form.controls.courseNameCtrl.value === null || this.edu_form.controls.courseNameCtrl.value === '' || this.edu_form.controls.courseNameCtrl.value === undefined) {
        this.courseValidation = false;
      } else {
        this.courseValidation = true;
      }

      if (this.edu_form.controls.collegeYearCtrl.value === null || this.edu_form.controls.collegeYearCtrl.value === '' || this.edu_form.controls.collegeYearCtrl.value === undefined) {
        this.collegeYearValidation = false;
      } else {
        this.collegeYearValidation = true;
      }

      if (this.edu_form.controls.overallclassCtrl.value === null || this.edu_form.controls.overallclassCtrl.value === '' || this.edu_form.controls.overallclassCtrl.value === undefined) {
        this.classValidation = false;
      } else {
        this.classValidation = true;
      }

      if (this.edu_form.controls.monthCtrl.value === null || this.edu_form.controls.monthCtrl.value === '' || this.edu_form.controls.monthCtrl.value === undefined) {
        this.monthValidation = false;
      } else {
        this.monthValidation = true;
      }

      if (this.edu_form.controls.yearCtrl.value === null || this.edu_form.controls.yearCtrl.value === '' || this.edu_form.controls.yearCtrl.value === undefined) {
        this.yearValidation = false;
      } else {
        this.yearValidation = true;
      }
    } else {
      var edu_data = {
        courseName: this.edu_form.controls.courseNameCtrl.value,
        collegeYear: this.edu_form.controls.collegeYearCtrl.value,
        overall_class: this.edu_form.controls.overallclassCtrl.value,
        month: this.edu_form.controls.monthCtrl.value,
        year: this.edu_form.controls.yearCtrl.value,
        overall_marks_obt: this.edu_form.controls.overmarksobtCtrl.value,
        overall_marks_out: this.edu_form.controls.overmarksoutCtrl.value,
        subjectFirst: this.subjectName ? this.subjectName['Course_Subject_name'] : this.withoutCodeSub,
        marks_obt_First: this.edu_form.controls.markFirstCtrl.value,
        marks_out_First: this.edu_form.controls.markFirstOutCtrl.value,
        subjectSecond: this.subjectName2 ? this.subjectName2['Course_Subject_name'] : this.withoutCodeSub2,
        marks_obt_Second: this.edu_form.controls.markSecondCtrl.value,
        marks_out_Second: this.edu_form.controls.markSecondOutCtrl.value,
        subjectThird: this.subjectName3 ? this.subjectName3['Course_Subject_name'] : this.withoutCodeSub3,
        marks_obt_Third: this.edu_form.controls.markThirdCtrl.value,
        marks_out_Third: this.edu_form.controls.markThirdOutCtrl.value,
        subjectFourth: this.subjectName4 ? this.subjectName4['Course_Subject_name'] : this.withoutCodeSub4,
        marks_obt_Fourth: this.edu_form.controls.markFourthCtrl.value,
        marks_out_Fourth: this.edu_form.controls.markFourthOutCtrl.value,
        subjectFifth: this.subjectName5 ? this.subjectName5['Course_Subject_name'] : this.withoutCodeSub5,
        marks_obt_Fifth: this.edu_form.controls.markFifthCtrl.value,
        marks_out_Fifth: this.edu_form.controls.markFifthOutCtrl.value,
        subjectSixth: this.subjectName6 ? this.subjectName6['Course_Subject_name'] : this.withoutCodeSub6,
        marks_obt_Six: this.edu_form.controls.markSixthCtrl.value,
        marks_out_Six: this.edu_form.controls.markSixthOutCtrl.value,
        subjectSeventh: this.subjectName7 ? this.subjectName7['Course_Subject_name'] : this.withoutCodeSub7,
        marks_obt_Seventh: this.edu_form.controls.markSeventhCtrl.value,
        marks_out_Seventh: this.edu_form.controls.markSeventhOutCtrl.value,
        subjectEighth: this.subjectName8 ? this.subjectName8['Course_Subject_name'] : this.withoutCodeSub8,
        marks_obt_Eighth: this.edu_form.controls.markEighthCtrl.value,
        marks_out_Eighth: this.edu_form.controls.markEighthOutCtrl.value,
        subjectNinth: this.subjectName9 ? this.subjectName9['Course_Subject_name'] : this.withoutCodeSub9,
        marks_obt_Ninth: this.edu_form.controls.markNinthCtrl.value,
        marks_out_Ninth: this.edu_form.controls.markNinthOutCtrl.value,
        subjectTenth: this.subjectName10 ? this.subjectName10['Course_Subject_name'] : this.withoutCodeSub10,
        marks_obt_Tenth: this.edu_form.controls.markTenthCtrl.value,
        marks_out_Tenth: this.edu_form.controls.markTenthOutCtrl.value,
        subjectElevanth: this.subjectName11 ? this.subjectName11['Course_Subject_name'] : this.withoutCodeSub11,
        marks_obt_Elevanth: this.edu_form.controls.markElevanthCtrl.value,
        marks_out_Elevanth: this.edu_form.controls.markElevanthOutCtrl.value,
        subjectTwelfth: this.subjectName12 ? this.subjectName12['Course_Subject_name'] : this.withoutCodeSub12,
        marks_obt_Twelfth: this.edu_form.controls.markTwelfthCtrl.value,
        marks_out_Twelfth: this.edu_form.controls.markTwelfthOutCtrl.value,
        user_id: this.user_id,
        medium_instruction: this.edu_form.controls.instructionCtrl.value,
        id: this.edu_id,
        lecture_hour_First: this.subjectName ? this.lec_per_week1 : this.edu_form.controls.lecturehourFirstCtrl.value,
        lecture_hour_Second: this.subjectName2 ? this.lec_per_week2 : this.edu_form.controls.lecturehourSecondCtrl.value,
        lecture_hour_Third: this.subjectName3 ? this.lec_per_week3 : this.edu_form.controls.lecturehourThirdCtrl.value,
        lecture_hour_Fourth: this.subjectName4 ? this.lec_per_week4 : this.edu_form.controls.lecturehourFourthCtrl.value,
        lecture_hour_Fifth: this.subjectName5 ? this.lec_per_week5 : this.edu_form.controls.lecturehourFifthCtrl.value,
        lecture_hour_Six: this.subjectName6 ? this.lec_per_week6 : this.edu_form.controls.lecturehourSixCtrl.value,
        lecture_hour_Seventh: this.subjectName7 ? this.lec_per_week7 : this.edu_form.controls.lecturehourSeventhCtrl.value,
        lecture_hour_Eighth: this.subjectName8 ? this.lec_per_week8 : this.edu_form.controls.lecturehourEighthCtrl.value,
        lecture_hour_Ninth: this.subjectName9 ? this.lec_per_week9 : this.edu_form.controls.lecturehourNinthCtrl.value,
        lecture_hour_Tenth: this.subjectName10 ? this.lec_per_week10 : this.edu_form.controls.lecturehourTenthCtrl.value,
        lecture_hour_Elevanth: this.subjectName11 ? this.lec_per_week11 : this.edu_form.controls.lecturehourElevanthCtrl.value,
        lecture_hour_Twelfth: this.subjectName12 ? this.lec_per_week12 : this.edu_form.controls.lecturehourTwelfthCtrl.value,
        practical_hour_First: this.subjectName ? this.prac_hour1 : this.edu_form.controls.practicalhourFirstCtrl.value,
        practical_hour_Second: this.subjectName2 ? this.prac_hour2 : this.edu_form.controls.practicalhourSecondCtrl.value,
        practical_hour_Third: this.subjectName3 ? this.prac_hour3 : this.edu_form.controls.practicalhourThirdCtrl.value,
        practical_hour_Fourth: this.subjectName4 ? this.prac_hour4 : this.edu_form.controls.practicalhourFourthCtrl.value,
        practical_hour_Fifth: this.subjectName5 ? this.prac_hour5 : this.edu_form.controls.practicalhourFifthCtrl.value,
        practical_hour_Six: this.subjectName6 ? this.prac_hour6 : this.edu_form.controls.practicalhourSixCtrl.value,
        practical_hour_Seventh: this.subjectName7 ? this.prac_hour7 : this.edu_form.controls.practicalhourSeventhCtrl.value,
        practical_hour_Eighth: this.subjectName8 ? this.prac_hour8 : this.edu_form.controls.practicalhourEighthCtrl.value,
        practical_hour_Ninth: this.subjectName9 ? this.prac_hour9 : this.edu_form.controls.practicalhourNinthCtrl.value,
        practical_hour_Tenth: this.subjectName10 ? this.prac_hour10 : this.edu_form.controls.practicalhourTenthCtrl.value,
        practical_hour_Elevanth: this.subjectName11 ? this.prac_hour11 : this.edu_form.controls.practicalhourElevanthCtrl.value,
        practical_hour_Twelfth: this.subjectName12 ? this.prac_hour12 : this.edu_form.controls.practicalhourTwelfthCtrl.value,
        total_weeks: this.edu_form.controls.totalweeksCtrl.value,
        special_instruction: this.edu_form.controls.specialInstrctionCtrl.value,
        specialization: this.edu_form.controls.specializationCtrl.value,
        doubbleDegree: this.doubbleDegree,
      }

      this.api.setEducationalValues(edu_data)
        .subscribe(
          (data: any) => {
            this.ref.close(data);
            err => console.error(err)
          });
    }
  }

  dismiss() {
    this.ref.close();
  }

  hetmarksObt() {
    this.totalMarks = 0;

    try {

      // List of all mark controls
      const markControls: string[] = [
        'markFirstCtrl',
        'markSecondCtrl',
        'markThirdCtrl',
        'markFourthCtrl',
        'markFifthCtrl',
        'markSixthCtrl',
        'markSeventhCtrl',
        'markEighthCtrl',
        'markNinthCtrl',
        'markTenthCtrl',
        'markElevanthCtrl',
        'markTwelfthCtrl'
      ];

      // Loop through the control array and sum the values if they are not empty
      markControls.forEach((controlName) => {
        const controlValue = this.edu_form.controls[controlName].value;
        if (controlValue !== '' && controlValue !== null && !isNaN(controlValue)) {
          this.totalMarks += Number(controlValue);
        }
      });
    } catch (error) {
      

    }
  }


  totalsMarksOut() {
    this.totalMarksOut = 0;

    // List of all mark controls
    const markControls = [
      'markFirstOutCtrl',
      'markSecondOutCtrl',
      'markThirdOutCtrl',
      'markFourthOutCtrl',
      'markFifthOutCtrl',
      'markSixthOutCtrl',
      'markSeventhOutCtrl',
      'markEighthOutCtrl',
      'markNinthOutCtrl',
      'markTenthOutCtrl',
      'markElevanthOutCtrl',
      'markTwelfthOutCtrl'
    ];

    // Loop through controls and sum the values if they are not empty
    markControls.forEach((controlName) => {
      const controlValue = this.edu_form.controls[controlName].value;
      if (controlValue !== '' && controlValue !== null) {
        this.totalMarksOut += Number(controlValue);
      }
    });
  }

  onDeleteSubject(no) {
    this.api.deleteRecords(this.user_id, this.edu_id, no)
      .subscribe(data => {
        if (data["status"] == 200) {
          this.ngOnInit();
          this.toasterService.success("Deleted successfully");
        }
      },
        (err) => console.error(err)
      );
  }

  showcoursecodeDropdown() {
    this.showcodeDropdown = true
  }

  showcoursecodeDropdown2() {
    this.showcodeDropdown2 = true
  }

  showcoursecodeDropdown3() {
    this.showcodeDropdown3 = true
  }

  showcoursecodeDropdown4() {
    this.showcodeDropdown4 = true
  }

  showcoursecodeDropdown5() {
    this.showcodeDropdown5 = true
  }

  showcoursecodeDropdown6() {
    this.showcodeDropdown6 = true
  }

  showcoursecodeDropdown7() {
    this.showcodeDropdown7 = true
  }

  showcoursecodeDropdown8() {
    this.showcodeDropdown8 = true
  }
  showcoursecodeDropdown9() {
    this.showcodeDropdown9 = true
  }
  showcoursecodeDropdown10() {
    this.showcodeDropdown10 = true
  }

  showcoursecodeDropdown11() {
    this.showcodeDropdown11 = true
  }

  showcoursecodeDropdown12() {
    this.showcodeDropdown12 = true
  }

  showContactDetails() {
    this.confirmationService.confirm({
      message: 'Email - stxaviers@etranscript.in &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;  &nbsp;' + ' Whatsapp - +91 99306 00066',
      header: 'Please contact the admin on ',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {

      },
      reject: () => {

      }
    });
  }


}